import type { Product } from '@/types/catalog';

/** A product is a preorder when the store marked it as "por ingresar". */
export function isPreorder(product: Pick<Product, 'status'>): boolean {
  return product.status === 'preorder';
}

/** Max units a customer may put in the cart for this product. */
export function maxOrderQty(product: Pick<Product, 'status' | 'stock' | 'preorder_limit'>): number {
  if (isPreorder(product)) return Math.max(1, product.preorder_limit ?? 5);
  return product.stock;
}

/** Human-friendly ETA label, e.g. "Llega en septiembre 2026". */
export function preorderEta(date?: string | null, lang: 'es' | 'en' = 'es'): string | null {
  if (!date) return null;
  const d = new Date(`${date}T12:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const formatted = d.toLocaleDateString(lang === 'en' ? 'en-US' : 'es-SV', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  return lang === 'en' ? `Estimated arrival: ${formatted}` : `Llegada estimada: ${formatted}`;
}
